import React, { Component } from 'react';
import moment from 'moment-timezone';
import { connect } from 'react-redux';
import * as Sentry from '@sentry/browser';
import { Redirect, withRouter } from 'react-router-dom';
import { fetchReservation, updateReservation } from './actions';

import './index.css';
import { selectStoreConfig } from '../Layout/selectors';

class ConfirmReservation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rating: 0,
      delay: false,
      rows: 2,
      keyBoard: false,
      height: 474,
      processingAccept: false,
      processingDeclined: false,
    };
  }

  componentDidMount() {
    let data = this.props.history.location.pathname.split('/');
    if (data.length === 3) {
      this.props.fetchReservationHandler(data[2]);
    } else {
      this.props.history.replace('/');
    }
    this.computeBookingInfoHeight();
    window.navigator.userAgent.match(/android/i) &&
      window.addEventListener(
        'resize',
        this.onElementHeightChange.bind(this, window.innerHeight)
      );
  }

  computeBookingInfoHeight = () => {
    let interim = 0;
    if (document.querySelector('.resCat.marginTop.handle-overflow')) {
      if (
        document.querySelector('.resCat.marginTop.handle-overflow')
          .offsetTop !== undefined
      ) {
        interim = document.querySelector(
          '.resCat.marginTop.handle-overflow'
        ).offsetTop;
      }
    }
    if (
      document.querySelector(
        '.visible-xs.visible-sm.reviewBarM.align-confirmation-buttons'
      )
    ) {
      let elem_height =
        window.screen.availHeight -
        document.querySelector(
          '.visible-xs.visible-sm.reviewBarM.align-confirmation-buttons'
        ).clientHeight -
        interim;

      //target_element.style.height = elem_height + 'px';
      this.setState({
        height: elem_height - 112,
      });
    }
  };

  componentDidUpdate(prevProps) {
    if (
      this.props.reservation.isReservationUpdated !==
      prevProps.reservation.isReservationUpdated
    ) {
      if (this.props.reservation.isReservationUpdated) {
        this.setState({
          processingAccept: false,
          processingDeclined: false,
        });
      }
    }
  }

  componentWillUnmount() {
    window.navigator.userAgent.match(/android/i) &&
      window.removeEventListener(
        'resize',
        this.onElementHeightChange.bind(this)
      );
    document.getElementById('root').classList.remove('hideRootScroll');
  }

  componentDidCatch(error, errorInfo) {
    Sentry.withScope((scope) => {
      Object.keys(errorInfo).forEach((key) => {
        scope.setExtra(key, errorInfo[key]);
      });
      Sentry.captureException(error);
    });
  }

  onElementHeightChange = (height) => {
    let lastHeight = height;
    let newHeight = window.innerHeight;
    if (lastHeight - newHeight > 125) {
      this.setState({ keyBoard: true });
    } else {
      if (this.state.keyBoard === true && lastHeight - newHeight === 0) {
        this.setState({ keyBoard: false });
      }
    }
  };

  updateReservation = (status) => {
    if (
      !(this.state.processingAccept && this.state.processingDeclined) &&
      this.props.reservation.reservation &&
      this.props.reservation.reservation.reservationStatus === '1'
    ) {
      this.setState(
        {
          processingAccept: status === '2' ? true : false,
          processingDeclined: status === '3' ? true : false,
        },
        () => {
          this.props.updateReservationHandler(
            this.props.reservation.reservation,
            status
          );
        }
      );
    }
  };

  rootOverflowRestrict = () => {
    document.getElementById('root').classList.add('hideRootScroll');
  };

  getReservationStatus = () => {
    if (
      this.props &&
      this.props.reservation &&
      this.props.reservation.reservation
    ) {
      if (this.props.reservation.reservation.reservationStatus === 2) {
        return 'CONFIRMED';
      } else if (this.props.reservation.reservation.reservationStatus === 3) {
        return 'DECLINED';
      } else if (this.props.reservation.reservation.reservationStatus === 1) {
        return 'Confirm Booking?';
      } else {
        return 'Confirm Booking?';
      }
    } else {
      return 'Confirm Booking?';
    }
  };

  render() {
    const { storeConfig } = this.props;
    return window.innerWidth < 992 ? (
      <div
        className={
          this.state.keyBoard
            ? `reviewsStar col-xs-12 keyB row${this.state.rows}`
            : 'reviewsStar col-xs-12'
        }
      >
        {this.rootOverflowRestrict()}
        <div className='detailsTitle'>{this.getReservationStatus()}</div>
        <div className='visible-xs visible-sm addressMobileBar shadowMobileBar'>
          <div
            className={`addB2 pick`}
            onClick={this.openTimeBar}
            style={{ color: '#4b4a4a', borderBottom: '1px solid #dbdbdb' }}
          >
            <i className='icon-Clock' />
            {storeConfig.name}
          </div>
          <div className='addB1' style={{ color: '#8e8e8e' }}>
            <i className='icon-Location-Pin' />
            {storeConfig.address}
          </div>
        </div>
        <div
          className='resCat marginTop handle-overflow'
          style={{ height: this.state.height }}
        >
          {this.props.reservation.reservation &&
          this.props.reservation.reservation.userName &&
          this.props.reservation.reservation.userName !== '' ? (
            <div>
              <div className='alignConfirmInfo bookingContent'>
                <div className='bookingLabel'>Name</div>
                <div className='bookingValue'>
                  {this.props.reservation.reservation.userName}
                </div>
              </div>
            </div>
          ) : (
            <div />
          )}
          {this.props.reservation.reservation &&
          this.props.reservation.reservation.mobileNumber &&
          this.props.reservation.reservation.mobileNumber !== '' ? (
            <div>
              <div className='alignConfirmInfo bookingContent'>
                <div className='bookingLabel'>Mobile Number</div>
                <div className='bookingValue'>
                  {this.props.reservation.reservation.mobileNumber}
                </div>
              </div>
            </div>
          ) : (
            <div />
          )}
          {this.props.reservation.reservation &&
          this.props.reservation.reservation.adults &&
          this.props.reservation.reservation.adults !== 0 ? (
            <div>
              <div className='alignConfirmInfo bookingContent'>
                <div className='bookingLabel'>
                  {this.props.reservation.reservation.adults === 1
                    ? 'Adult'
                    : 'Adults'}
                </div>
                <div className='bookingValue'>
                  {this.props.reservation.reservation.adults}
                </div>
              </div>
            </div>
          ) : (
            <div />
          )}
          {this.props.reservation.reservation &&
          this.props.reservation.reservation.children &&
          this.props.reservation.reservation.children !== 0 ? (
            <div>
              <div className='alignConfirmInfo bookingContent'>
                <div>
                  <div className='bookingLabel'>
                    {this.props.reservation.reservation.children === 1
                      ? 'Child'
                      : 'Children'}
                  </div>
                  <div className='alignConfirmInfoSpan resetMargin'>
                    Ages 2-12
                  </div>
                </div>
                <div className='bookingValue'>
                  {this.props.reservation.reservation.children}
                </div>
              </div>
            </div>
          ) : (
            <div />
          )}
          {this.props.reservation.reservation &&
          this.props.reservation.reservation.infants &&
          this.props.reservation.reservation.infants !== 0 ? (
            <div>
              <div className='alignConfirmInfo bookingContent'>
                <div>
                  <div className='bookingLabel'>
                    {this.props.reservation.reservation.infants === 1
                      ? 'Infant'
                      : 'Infants'}
                  </div>
                  <div className='alignConfirmInfoSpan resetMargin'>
                    Ages 0-2
                  </div>
                </div>
                <div className='bookingValue'>
                  {this.props.reservation.reservation.infants}
                </div>
              </div>
            </div>
          ) : (
            <div />
          )}
          {this.props.reservation.reservation &&
          this.props.reservation.reservation.reservationDate &&
          this.props.reservation.reservation.reservationDate !== '' ? (
            <div>
              <div className='alignConfirmInfo bookingContent'>
                <div>
                  <div className='bookingLabel'>Reservation Date</div>
                </div>
                <div className='bookingValue'>
                  {moment(
                    this.props.reservation.reservation.reservationDate
                  ).format('h:mm A ddd, Do MMM')}
                </div>
              </div>
            </div>
          ) : (
            <div />
          )}
          {this.props.reservation.reservation &&
          this.props.reservation.reservation.notes &&
          this.props.reservation.reservation.notes !== '' ? (
            <div>
              <div className='alignConfirmInfo bookingContent notes-wrap'>
                <div>
                  <div
                    className='bookingLabel'
                    style={{ marginBottom: '1rem' }}
                  >
                    Notes
                  </div>
                </div>
                <div className='bookingValue'>
                  {this.props.reservation.reservation.notes}
                </div>
              </div>
            </div>
          ) : (
            <div />
          )}
        </div>
        <div
          className={`visible-xs visible-sm reviewBarM align-confirmation-buttons ${
            this.props.reservation.reservation &&
            this.props.reservation.reservation.reservationStatus === '1'
              ? ''
              : 'disable-action-buttons'
          }`}
        >
          {this.state.processingAccept ? (
            <span className='comM notesM approve-action'>
              <img
                height='25px'
                src='https://pics.nextorder.co/assets/next-loading.svg'
                alt=''
              />
            </span>
          ) : (
            <div
              className='comM notesM approve-action'
              onClick={() => this.updateReservation('2')}
            >
              Accept
            </div>
          )}
          {this.state.processingDeclined ? (
            <span className='comM notesM decline-action'>
              <img
                height='25px'
                src='https://pics.nextorder.co/assets/next-loading.svg'
                alt=''
              />
            </span>
          ) : (
            <div
              className='comM timeRM decline-action'
              onClick={() => this.updateReservation('3')}
            >
              Decline
            </div>
          )}
        </div>
      </div>
    ) : (
      <Redirect to='/' />
    );
  }
}

function mapStateToProps(state) {
  return {
    reservation: state.reservationReducer,
    storeConfig: selectStoreConfig(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchReservationHandler: (reservationId) =>
      dispatch(fetchReservation(reservationId)),
    updateReservationHandler: (reservation, status) =>
      dispatch(updateReservation(reservation, status)),
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ConfirmReservation)
);
